import { render, staticRenderFns } from "./GuppyChatPrivateList.vue?vue&type=template&id=045fec8e"
import script from "./GuppyChatPrivateList.vue?vue&type=script&lang=js"
export * from "./GuppyChatPrivateList.vue?vue&type=script&lang=js"
import style0 from "./GuppyChatPrivateList.vue?vue&type=style&index=0&id=045fec8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports